var exports = {
  "kL": "xdbfd91f1--b060d5--container",
  "Kk": "xdbfd91f1--b060d5--icon",
  "VA": "xdbfd91f1--b060d5--subtitle",
  "id": "xdbfd91f1--b060d5--discount",
  "P2": "xdbfd91f1--b060d5--mortgage",
  "sT": "xdbfd91f1--b060d5--maternal-capital",
  "RH": "xdbfd91f1--b060d5--military-mortgage",
  "of": "xdbfd91f1--b060d5--bonus",
};

module.exports = exports;
